// extracted by mini-css-extract-plugin
module.exports = {"resultWrapper":"DialogResultWidget_resultWrapper__121ON","actionButton":"DialogResultWidget_actionButton__1LDnV"};